/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import flowGraphConditionalDataBlock.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./flowGraphConditionalDataBlock.pure";
import { RegisterFlowGraphConditionalDataBlock } from "./flowGraphConditionalDataBlock.pure";
RegisterFlowGraphConditionalDataBlock();
//# sourceMappingURL=flowGraphConditionalDataBlock.js.map